import api from '@/plugins/apiService'
const getOpenFolderId = () => {
  const consoleState = localStorage.getItem('pdfOpenFolderId')
  if (consoleState) {
    return consoleState
  }

  return null
}

export default {
  namespaced: true,
  state: {
    selectedPageNames: [],
    allSelectedPageNames: [],
    allSelectedPageIds: [],
    selectedPageIds:[],
    searchPages: [],
    isSearchPages: false,
    rotatePages: {},
    leftPlansTab: 1, // takeoff & plans tab index left sidebar
    planPages: [],
    intialLoading: false,
    visualDataLoading: false,
    transfer_visual_data: {},
    selectedPages: [],
    activeCaliber: {},
    bookmarks: [],
    openFolderId: getOpenFolderId(),
    pageVersions: [],
    pageHistory: [],
    currentPage: null,
    selectedPdfId: null,
    selectedProjects:[]
  },
  getters: {
    GET_SELECTED_PAGE_NAMES: state => state.selectedPageNames,
    GET_ALL_SELECTED_PAGE_NAMES: state => state.allSelectedPageNames,
    GET_ALL_SELECTED_PAGE_IDS: state => state.allSelectedPageIds,
    GET_SELECTED_PAGE_IDS: state => state.selectedPageIds,
    GET_SEARCH_PAGES: state => state.searchPages,
    GET_IS_SEARCH_PAGES: state => state.isSearchPages,
    GET_PAGE_ROTATION: state => state.rotatePages,
    GET_LEFT_PLANS_TAB: state => state.leftPlansTab,
    GET_PLAN_PAGES: state => state.planPages,
    GET_INITIAL_LOADING: state => state.intialLoading,
    GET_VISUALDATA_LOADING: state => state.visualDataLoading,
    GET_SELECTED_PAGES: state => state.selectedPages,
    GET_SELECTED_PDF_ID: state => state.selectedPdfId,
    GET_OPEN_FOLDER_ID: state => state.openFolderId,
    GET_PDF_PLANS: state => {
      // get uique pdf from array
      const arrayUniqueByKey = [
        ...new Map(state.planPages.map(item => [item.pdf_id, item])).values(),
      ]
      return arrayUniqueByKey.sort((a, b) => {
        const aStartsWithNum = /^\d/.test(a.name);
        const bStartsWithNum = /^\d/.test(b.name);

        if (aStartsWithNum && bStartsWithNum) {
          return parseInt(a.name) - parseInt(b.name);
        } else if (aStartsWithNum) {
          return -1;
        } else if (bStartsWithNum) {
          return 1;
        } else {
          return a.name.localeCompare(b.name);
        }
      });
    },
    GET_PDF_PLANS_TO_MOVE: state => {
      // get uique pdf from array
      const arrayUniqueByKey = [
        ...new Map(state.planPages.filter(page => page.pdf_id !== state.selectedPdfId).map(item => [item.pdf_id, item])).values(),
      ]

      return arrayUniqueByKey
    },
    GET_TRANSFER_VISUAL_DATA: state => {
      return state.transfer_visual_data
    },
    GET_ACTIVE_CALIBER: state => {
      return state.activeCaliber
    },
    GET_BOOKMARK_PAGES: state => {
      return state.bookmarks
    },
    GET_IS_PROCESSING: state => {
      const pages = state.planPages.filter(opt => opt.content_type !== null)

      return pages.some(opt => opt.is_processed < 4)
    },
    GET_PAGE_VERSIONS: state => state.pageVersions,
    GET_PAGE_HISTORY: state => state.pageHistory,
    GET_CURRENT_PAGE: state => state.currentPage,
    GET_SELECT_PROJECTS: state => state.selectedProjects,
  },
  mutations: {
    SET_SELECTED_PAGE_NAMES(state, selectedNames) {
      state.selectedPageNames = selectedNames
    },

    SET_ALL_SELECTED_PAGE_NAMES(state, allSelectedNames) {
      state.allSelectedPageNames = allSelectedNames
    },

    SET_ALL_SELECTED_PAGE_IDS(state, allSelectedIds) {
      state.allSelectedPageIds = allSelectedIds
    },
    SET_SELECTED_PAGE_IDS(state, allSelectedIds) {
      state.selectedPageIds = allSelectedIds
    },

    SET_SEARCH_PAGES: (state, payload) => {
      state.searchPages = payload
    },
    SET_PLAN_PAGES: (state, payload) => {
      state.planPages = payload
    },
    SET_IS_SEARCH_PAGES: (state, payload) => {
      state.isSearchPages = payload
    },
    SET_LEFT_PLANS_TAB: (state, payload) => {
      state.leftPlansTab = payload
    },
    SET_INITIAL_LOADING: (state, payload) => {
      state.intialLoading = payload
    },
    SET_VISUALDATA_LOADING: (state, payload) => {
      state.visualDataLoading = payload
    },
    SET_PAGE_SIGNED_URL: (state, payload) => {
      const planPages = state.planPages
      const index = planPages.findIndex(opt => {
        return opt.page_id === payload.page_id
      })
      if (index !== -1) {
        const page = state.planPages[index]
        page.signedURL = payload.signedURL
        state.planPages = [...state.planPages, page]
      }
    },
    SET_PAGE_ROTATION: (state, payload) => {
      const uuid = payload.uuid
      if (state.rotatePages[payload.uuid]) {
        let rotation = state.rotatePages[payload.uuid] + 90
        if (rotation === 360) {
          rotation = 0
        }
        state.rotatePages = {
          ...state.rotatePages,
          [uuid]: rotation,
        }
      } else {
        state.rotatePages = {
          ...state.rotatePages,
          [uuid]: 90,
        }
      }
    },
    SET_CURRENT_PAGE: (state, payload) => {
      state.currentPage = payload
    },
    UPDATE_PAGE_NAME: (state, payload) => {
      state.currentPage.page_name = payload.name
      state.currentPage.page_description = payload.page_description
    },
    SET_TRANSFER_VISUAL_DATA: (state, payload) => {
      state.transfer_visual_data = payload
    },
    SET_ACTIVE_CALIBER: (state, payload) => {
      const uuid = payload.uuid
      state.activeCaliber = {
        ...state.activeCaliber,
        [uuid]: payload.name,
      }
    },
    RESET_TRANSFER_VISUAL_DATA: state => {
      state.transfer_visual_data = {}
    },
    SET_PLAN_PAGES_AFTER_DELETE: (state, payload) => {
      const currentPages = [...state.planPages]
      const totalPagesByPdf = currentPages.filter(opt => {
        return opt.pdf_id == state.selectedPdfId
      })
      const removeDeletePages = currentPages.filter(opt => {
        return !payload.includes(opt.page_id)
      })
      //FIXME: setting a defult entry to avoid folder deletion
      // later we will fetch only folders and then on click we will
      // fetch pages
      if(totalPagesByPdf.length == 1){
        removeDeletePages.push({
          "page_no": null,
          "version": null,
          "page_description": null,
          "file_id": null,
          "pdf_id": totalPagesByPdf[0].pdf_id,
          "is_processed": null,
          "content_type": ".pdf",
          "name": totalPagesByPdf[0].name,
          "page_id": null,
          "file_path": null,
          "page_name": null,
          "image_path": null,
          "ocr_page_name": null,
          "updatedAt": null,
          "height": null,
          "width": null,
          "signedURL": null,
          "imgURL": null
        })
      }
      state.planPages = removeDeletePages
    },
    SET_SELECTED_PAGES: (state, payload) => {
      state.selectedPages = payload
    },
    SET_PDF_ID: (state, payload) => {
      state.selectedPdfId = payload
    },
    SET_INTERCHANGE_PAGES: (state, payload) => {
      const planPages = structuredClone(state.planPages)
      const currentPdf = state.planPages.find(opt => {
        return opt.pdf_id == state.selectedPdfId
      })
      payload.forEach(element => {
        const index = planPages.findIndex(opt => {
          return opt.page_id === element.page_id
        })
        if (index !== -1) {
          planPages[index] = element
          state.planPages = [...planPages]
        }
      })
      const totalPagesByPdf = state.planPages.filter(opt => {
        return opt.pdf_id == state.selectedPdfId
      })
      console.log('totlapages', totalPagesByPdf)
      if(!totalPagesByPdf.length){
        state.planPages.push({
          "page_no": null,
          "version": null,
          "page_description": null,
          "file_id": null,
          "pdf_id": currentPdf.pdf_id,
          "is_processed": null,
          "content_type": ".pdf",
          "name": currentPdf.name,
          "page_id": null,
          "file_path": null,
          "page_name": null,
          "image_path": null,
          "ocr_page_name": null,
          "updatedAt": null,
          "height": null,
          "width": null,
          "signedURL": null,
          "imgURL": null
        })
      }
    },
    SET_BOOKMARK: (state, payload) => {
      state.bookmarks = payload
    },
    RESET_BOOKMARK: state => {
      state.bookmarks = []
    },
    SET_OPEN_FOLDER_ID: (state, payload) => {
      state.openFolderId = payload
      window.localStorage.setItem('pdfOpenFolderId', payload)
    },
    SET_VERSION_PAGES: (state, payload) => {
      state.pageVersions = payload
    },
    SET_SELECT_PROJECTS:(state,payload)=>{
      state.selectedProjects = payload
    }
  },
  actions: {
    PAGE_FIELD_DELETE: ({ commit, getters }, payload) => {
      const pages = getters.GET_SELECTED_PAGES

      const object = {
        page_id: pages,
      }
      return api
        .delete(`field-management/${payload.project_id}/page/delete`, { data: object })
        .then(({ data }) => {
          if (data.success) {
            commit('SET_PLAN_PAGES_AFTER_DELETE', pages)
            commit('SET_SELECTED_PAGES', [])
          }
        })
        .catch(error => {
          throw error
        })
    },
    PAGE_DELETE: ({ commit, getters }, payload) => {
      const pages = getters.GET_SELECTED_PAGES

      const object = {
        page_id: pages,
      }
      api
        .delete(`estimations/${payload.estimationId}/page/delete`, { data: object })
        .then(({ data }) => {
          if (data.success) {
            commit('SET_PLAN_PAGES_AFTER_DELETE', pages)
            commit('SET_SELECTED_PAGES', [])
          }
        })
    },
    COPY_PAGES: ({ getters, dispatch }, payload) => {

      const object = {
        page_id: payload.page_id,
        prop_id: payload.prop_id,
        prop_type: 'estimations',
      }

      api.save(`workdrive/pages/${payload.pdf_id}/copy`, object).then(({ data }) => {
        if (data.success) {
          commit('SET_SELECTED_PAGES', [])
          // fetch
          dispatch('FETCH_ALL_PDF_PAGES', {
            prop_id: payload.pdf_id,
            prop_type: 'estimations',
            intialLoading: false,
          })
        }
      })
    },
    DOWNLOAD_PAGES: async ({ commit, getters }, payload) => {
      const pages = getters.GET_SELECTED_PAGES
      const pdf_id = getters.GET_SELECTED_PDF_ID

      if (!pages.length || !pdf_id) return

      const object = { pages, prop_type: payload.prop_type }
      try {
        const { data } = await api.save(`workdrive/estimation/downloadPdf/${payload.uuid}`, object)

        if (data?.success) {
          commit('SET_SELECTED_PAGES', [])
          commit('SET_PDF_ID', '')
        }
      } catch (error) {
        console.error('Error during page download:', error)
      }
    },
    FETCH_ALL_PDF_PAGES: async ({ commit, state, dispatch }, payload) => {
      const config = {
        prop_type: payload.prop_type,
        prop_id: payload.prop_id,
        parent_id: payload.parent_id,
        search: payload.search,
      }
      commit('SET_INITIAL_LOADING', payload.intialLoading)
      api
        .findByParams('workdrive/plans/pages', { params: config })
        .then(({ data }) => {
          if (data.data?.length) {
            const modifiedData = data.data.map(opt => {
              const obj = { ...opt }
              delete obj.signedURL

              return {
                ...obj,
              }
            })
            commit('SET_PLAN_PAGES', modifiedData)
          } else {
            commit('SET_PLAN_PAGES', [])
          }
        })
        .finally(() => {
          commit('SET_INITIAL_LOADING', false)
        })
    },
    FETCH_ALL_PAGE_VERSIONS: async ({ commit }, payload) => {
      commit('SET_VERSION_PAGES', [])
      api
        .findByParams(`workdrive/pdf/${payload.pdf_id}/page/${payload.page_no}`)
        .then(({ data }) => {
          commit('SET_VERSION_PAGES', data.data)
        })
        .catch(error => {
          console.error(error)
          commit('SET_VERSION_PAGES', [])
        })
    },
    FETCH_BOOKMARKS: ({ commit }, payload) => {
      api
        .findAll(`${payload.component}`)
        .then(({ data }) => {
          if (data.success && data.data) {
            const response = data.data
            commit('SET_BOOKMARK', response)
          } else {
            commit('RESET_BOOKMARK')
          }
        })
        .catch(() => {
          commit('RESET_BOOKMARK')
        })
    },
  },
}
